export default "__VITE_ASSET__BgO$9IQ1__"